/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personal_Program_Status_CancelledInputs */

const fr_personal_program_status_cancelled = /** @type {(inputs: Personal_Program_Status_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulé`)
};

/**

* @param {Personal_Program_Status_CancelledInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const personal_program_status_cancelled = /** @type {((inputs?: Personal_Program_Status_CancelledInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personal_Program_Status_CancelledInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_personal_program_status_cancelled(inputs)
});